import styled from 'styled-components'

export const TradingCentralIframeStyled = styled.iframe.attrs((props) => ({
    allowFullScreen: true,
    width: '100%',
    height: '100%',
}))``
